"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadComponent = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const FederatedModule_1 = require("./FederatedModule");
function loadComponent(scope, module) {
    return async () => {
        await __webpack_init_sharing__(FederatedModule_1.SHARE_SCOPE);
        const container = window[scope];
        await container.init(__webpack_share_scopes__[FederatedModule_1.SHARE_SCOPE]);
        const factory = await container.get(module);
        const Module = factory();
        return Module;
    };
}
exports.loadComponent = loadComponent;
